module.exports = __webpack_public_path__ + "img/banner-1.036c78dd.jpg";